import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ResponsibilityGroupState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allData: [] | null | any;
}

const initialState: ResponsibilityGroupState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allData: null,
};

export const responsibilityGroupSlice = createSlice({
  name: 'responsibilityGroup',
  initialState,
  reducers: {
    // For paginated fetch (default listing)
    setAllResponsibilityGroup: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setResGroupAll: (state, action) => {
      state.allData = action.payload.data;
    },

    // For search results
    setAllResponsibilityGroupBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.totalRecords;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
    },

    // Reset all state
    reset: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const { setAllResponsibilityGroup, setAllResponsibilityGroupBySearch, setResGroupAll, reset } = responsibilityGroupSlice.actions;
export const getAllResponsibilityGroupDetails = (state: RootState) => state.responsibilityGroup.data;
export const getAllResponsibilityGroupBySearch = (state: RootState) => state.responsibilityGroup.data;
export const getResponsibilityGroupTotalRecords = (state: RootState) => state.responsibilityGroup.totalRecords;
export const findAllResGroupDetails = (state: RootState) => state.responsibilityGroup.allData;

export default responsibilityGroupSlice.reducer;